// extracted by mini-css-extract-plugin
module.exports = {"joinCompanyHeader":"styles_joinCompanyHeader__3j1ok","joinNowText":"styles_joinNowText__240vE","logo":"styles_logo__RMt_F","joinButton":"styles_joinButton__m1gKR"};